import { SIGN_AGREEMENT } from 'Router/routes';
import { FakePageData } from '@4finance/cwt-test-helper';

const signAgreementScenarios: FakePageData = {
  url: SIGN_AGREEMENT,
  items: {
    'Fill the code': [
      ['[data-test="phoneCode-multifield"]', '9876'],
      ['[data-test="phoneCode-submitBtn"]', 'submit-button'],
    ],
  },
};

export { signAgreementScenarios };
